import primaryComponents from "../../../../primaryComponents";
import { useCheckoutCustomer } from "../../CheckoutCustomer/useCheckoutCustomer";
import { CustomerSelection } from "../../CheckoutCustomer/CustomerSelection";
import { useContext } from "react";
import { ToastContext } from "../../../../../hooks/context";
import { useCheckoutHelper } from "../../../../../hooks/useCheckoutHelper";

export const CreditDetails = ({
  closeModal = () => {},
  updatePayment = () => {},
}) => {
  const triggerToast = useContext(ToastContext);
  const { payment } = useCheckoutHelper();
  const { customerInfo, setCustomerInfo } = useCheckoutCustomer();

  return (
    <>
      <div className="p-2">
        <h4 className="text-center mb-3">Add Debit Details</h4>
        <CustomerSelection
          customerInfo={customerInfo}
          setCustomerInfo={(data) => {
            setCustomerInfo(data);
          }}
        />
        <br />

        <primaryComponents.DateInput
          label={"Repayment Date"}
          floatError={false}
          value={payment?.pay_with_credit?.repayment_date}
          onChange={({ target: { value } }) => {
            updatePayment("repayment_date", value);
          }}
        />

        <primaryComponents.Button
          classNames={"btn btn--primary cover mt-4"}
          onClick={() => {
            if (!customerInfo)
              return triggerToast(
                "Please ensure a customer as been selected before proceeding with credit payment",
              );

            closeModal();
          }}
        >
          Apply
        </primaryComponents.Button>
      </div>
    </>
  );
};
